interface LoadingProps {
  size?: "sm" | "md" | "lg";
  overlay?: boolean;
  className?: string;
}

export const Loading = ({
  size = "lg",
  overlay = true,
  className,
}: LoadingProps) => {
  if (!overlay) {
    return <LoadingSpinner size={size} className={className} />;
  }

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/50 backdrop-blur-sm">
      <LoadingSpinner />
    </div>
  );
};

interface LoadingSectionProps {
  targetId: string; // ID of the target element
  size?: "sm" | "md" | "lg";
  className?: string;
}

export const LoadingSection = ({
  targetId,
  size = "lg",
  className,
}: LoadingSectionProps) => {
  const targetElement = document.getElementById(targetId);

  if (!targetElement) {
    console.warn(`Element with ID "${targetId}" not found.`);
    return null;
  }

  return (
    <div
      className="absolute z-[9999] flex items-center justify-center bg-white/50 backdrop-blur-sm"
      style={{
        top: targetElement.offsetTop,
        left: targetElement.offsetLeft,
        width: targetElement.offsetWidth,
        height: targetElement.offsetHeight,
        position: "absolute",
      }}
    >
      <LoadingSpinner size={size} className={className} />
    </div>
  );
};

export const LoadingSpinner = ({ size = "lg", className }: LoadingProps) => {
  const sizeClasses = {
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-12 h-12",
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      {/* Spinning icon */}
      <div
        className={`${sizeClasses[size]} border-4 border-grey-300 border-t-cyan rounded-full animate-spin`}
      />
    </div>
  );
};

export const BouncingDots = () => {
  return (
    <div className="w-full h-full flex items-center justify-center gap-4">
      <div className="w-4 h-4 rounded-full bg-cyan animate-bounce" style={{ animationDelay: "0s" }}></div>
      <div className="w-4 h-4 rounded-full bg-cyan animate-bounce start-[0.5rem]" style={{ animationDelay: "0.2s" }}></div>
      <div className="w-4 h-4 rounded-full bg-cyan animate-bounce start-1" style={{ animationDelay: "0.4s" }}></div>
    </div>
  );
};